import { Tooltip } from "antd";

import React from "react";

import "./teammember_project_renderer.less";
import {
  setDetailsModalVisible,
  setSelectedRequestId,
} from "@src/services/slices/requestOverviewSlice";
import { useAppDispatch } from "@src/setupStore";

import * as constants from "../../../../constants";

interface ProjectValue {
  fullName: string;
  genericRole: {
    genericRoleName: string;
  };
  projectName: string;
  specificRole?: string;
  projectRoleRequestId: number;
  status?: string;
}

interface TeamMemberProjectRendererProps {
  value: ProjectValue;
}

const TeamMemberProjectRenderer: React.FC<TeamMemberProjectRendererProps> = ({
  value,
}) => {
  const dispatch = useAppDispatch();
  const proposedClass =
    value.status === constants.REQUEST_STATUS.PROPOSED
      ? "project-name-proposed"
      : "project-name";

  const projectNameRenderer = (projectName: string): string => {
    return projectName.length > 50
      ? projectName.substring(0, 50) + "..."
      : projectName;
  };

  const handleClick = (roleRequestId: number): void => {
    dispatch(setDetailsModalVisible(true));
    dispatch(setSelectedRequestId(roleRequestId));
  };

  return (
    <Tooltip
      title={`${value.projectName} ${
        value.specificRole ? ", " + value.specificRole : ""
      }`}
      data-testid="tooltip"
    >
      <div className="project-name-section">
        {value.projectName !== "Time Blocker" ? (
          <a
            onClick={() => handleClick(value.projectRoleRequestId)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="link-to-project"
          >
            <span className={`${proposedClass}`} data-testid="project-name">
              {projectNameRenderer(value.projectName)}
            </span>
          </a>
        ) : (
          <span className="member-name" data-testid="time-blocker">
            {value.projectName}
          </span>
        )}

        {value.specificRole && (
          <>
            <span className="hyphen" data-testid="hyphen">
              -
            </span>
            <span className="role-text" data-testid="specific-role">
              {value.specificRole}
            </span>
          </>
        )}
      </div>
    </Tooltip>
  );
};

export default TeamMemberProjectRenderer;
